<template>
  <section class="activetime-by-typecomponent-events">
    <div class="activetime-by-typecomponent-events__header">
      <div class="activetime-by-typecomponent-events__header__cont-select-matchs">
        <div class="activetime-by-typecomponent-events__header__cont-select-matchs__label">
          Tipo:
        </div>
        <div class="activetime-by-typecomponent-events__header__cont-select-matchs__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect :value="action" placeholder="Seleccione" expanded @input="onChangeAction">
              <option v-for="action in actions" :key="action.id" :value="action.id">
                {{ action.name }}
              </option>
            </BSelect>
          </BField>
        </div>
      </div>
      <div class="activetime-by-typecomponent-events__header__cont-select-matchs">
        <div class="activetime-by-typecomponent-events__header__cont-select-matchs__label">
          Jornadas:
        </div>
        <div class="activetime-by-typecomponent-events__header__cont-select-matchs__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect :value="match" placeholder="Seleccione" expanded @input="onChangeMatch">
              <option v-for="match in matchdays" :key="match.id" :value="match.id">
                {{ match.name }}
              </option>
            </BSelect>
          </BField>
        </div>
      </div>
    </div>
    <div class="activetime-by-typecomponent-events__header-two">
      <div
        class="activetime-by-typecomponent-events__header-two__btn-referee"
        :class="typeSelect == 'referee' ? 'active' : ''"
        @click="clickTypeEvent('referee')"
      >
        <div class="activetime-by-typecomponent-events__header-two__btn-referee__text">Arbitros</div>
        <div class="activetime-by-typecomponent-events__header-two__btn-referee__icon">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/silbato.png" />
        </div>
      </div>
      <div
        class="activetime-by-typecomponent-events__header-two__btn-teams"
        :class="typeSelect == 'teams' ? 'active' : ''"
        @click="clickTypeEvent('teams')"
      >
        <div class="activetime-by-typecomponent-events__header-two__btn-teams__text">Equipos</div>
        <div class="activetime-by-typecomponent-events__header-two__btn-teams__icon">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_previas.png" />
        </div>
      </div>
    </div>
    <div class="activetime-by-typecomponent-events__table-cont">
      <template v-if="typeSelect == 'referee'">
        <TableRefereeTypeEvents :key="updatesection" :referees="events.referees" @orderReferee="orderReferee" />
      </template>
      <template v-else>
        <TableTeamsTypeEvents :key="updatesection" :teams="events.teams" @orderTeams="orderTeams" />
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ActiveTimeByTypeEventsComponent',
  props: {
    matchdays: {
      type: Array,
      default: () => [],
    },
    events: {
      type: Object,
      default: () => {},
    },
    actions: {
      type: Array,
      default: () => [],
    },
    match: {
      type: Number,
      default: 0,
    },
    action: {
      type: Number,
      default: 5,
    },
  },
  components: {
    TableRefereeTypeEvents: () => import('@/components/ActiveTime/Elements/TableRefereeTypeEvents'),
    TableTeamsTypeEvents: () => import('@/components/ActiveTime/Elements/TableTeamsTypeEvents'),
  },
  computed: {},
  data() {
    return {
      typeSelect: 'referee',
      updatesection: 0,
    };
  },
  methods: {
    clickTypeEvent(type) {
      this.typeSelect = type;
    },
    showEmit(flag) {
      this.$emit('show', flag);
    },
    onChangeMatch(val) {
      this.$emit('onChangeMatch', val);
      this.updatesection += 1;
    },
    onChangeAction(val) {
      this.$emit('onChangeAction', val);
      this.updatesection += 1;
    },
    orderTeams(val) {
      this.$emit('orderTeams', val);
    },
    orderReferee(val) {
      this.$emit('orderReferee', val);
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.active {
  background: #cbee6e !important;
  cursor: pointer !important;
  border: solid 1px #cbee6e !important;
  &:hover {
    cursor: default !important;
  }
}
.activetime-by-typecomponent-events {
  width: 93%;
  height: 355px;
  // background: yellowgreen;
  margin: 0 auto;
  display: inline-block;
  &__table-cont {
    width: 100%;
    height: 204px;
    margin-top: 10px;
  }
  &__btn-more {
    width: 100%;
    height: 41px;
    margin-top: 7px;
    border-radius: 8px;
    border: solid 2px #d6dce8;
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 37px;
    letter-spacing: -0.34px;
    text-align: center;
    font-family: 'Avenir-Demi';
    color: #132739;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
  &__header-two {
    width: 100%;
    height: 32px;
    margin-top: 10px;
    display: inline-flex;
    align-content: center;
    &__btn-referee {
      width: 49.64%;
      height: 32px;
      border-radius: 6px;
      border: solid 1px #bfc9d2;
      background-color: #fff;
      display: inline-flex;
      justify-content: center;
      align-content: center !important;
      align-items: center !important;
      &__text {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.32px;
        text-align: center;
        color: #132739;
        font-family: 'Avenir-Demi';
      }
      &__icon {
        margin-left: 4.5%;
        img {
          width: 26.5px;
          margin-top: 7px;
        }
      }
      &:hover {
        background: #cbee6e;
        cursor: pointer;
        border: solid 1px #cbee6e;
      }
    }
    &__btn-teams {
      width: 49.64%;
      height: 32px;
      border-radius: 6px;
      border: solid 1px #bfc9d2;
      background-color: #fff;
      margin-left: 0.68%;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      &__text {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.32px;
        text-align: center;
        color: #132739;
        font-family: 'Avenir-Demi';
      }
      &__icon {
        margin-left: 5%;
        img {
          width: 21.4px;
          margin-top: 7px;
        }
      }
      &:hover {
        background: #cbee6e;
        cursor: pointer;
        border: solid 1px #cbee6e;
      }
    }
  }
  &__header {
    width: 100%;
    height: 122px;
    &__cont-select-matchs {
      width: 100%;
      height: 56px;
      margin-top: 8px;
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-family: 'Roboto-Medium';
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        padding-left: 2px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
      }
    }
  }
}
</style>
